export default "__VITE_ASSET__h1_Ql7Mc__"